import React from "react"
import './index.css'

interface ContainerProps {
    children: React.ReactNode;
}

export default function PageContainer(props: ContainerProps) {
    const { children } = props;
    return (
        <div className="page-container">
            {children}
        </div>
    )
}